// tslint:disable

import { AxiosResponse } from 'axios';
import * as Cookie from 'js-cookie';
import { get } from 'lodash';
import * as handlebars from 'handlebars';
import axios from 'axios';
import { Environment } from '../../environment/environment';

export class MetadataReaderLib {
    public user: any = null;
    public site: any = null;
    public sites: any = null;
    public meta: any = null;
    public env: any = null;
    public url: URL = new URL((window as any).location.href);

    public static async init() {
        try {
            const response: AxiosResponse = await axios.get(Environment.get('api.meta'));
            Cookie.set('meta', response.data);
            return Promise.resolve(response.data);
        }catch (err) {
            return Promise.reject(err);
        }
    }

    constructor(context: any) {
        try {
            this.user = JSON.parse(Cookie.get('user') as any);
            this.site = JSON.parse(Cookie.get('site') as any);
            this.sites = JSON.parse(Cookie.get('sites') as any);
            this.meta = JSON.parse(Cookie.get('meta') as any);

        } catch (err) {
            console.log('Cannot read metadata', err.message);
            this.user = null;
            this.site = null;
            this.sites = null;
            this.meta = null;
        }
    }

    public getLink(entity: string, data: any) {
        const ent = get(this.urls, entity);
        const currentSiteId = this.site['id']
        const context = get(ent, currentSiteId);
        return 'http://'+this.meta.env+"."+get(this.site, 'domain')+handlebars.compile(context)(data);
    }

    public urls: any = {
        "article": {
            1: "/news/{{slug}}",
            2: "/news/{{fullSlug}}"
        },
        "article-destination": {
            1: "/destination/${slug}",
            2: "/location/${fullSlug}"
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/metadata-reader.lib.ts